export class Pagination{
    public lignes: number;
    public page: number;
    constructor(lignes:number, page:number){
        this.lignes=lignes
        this.page=page
    }
};